<div class="preview">
  @if (mediaPath && isImageType) {
    <img
      style="width: 100%; max-width: 450px"
      [src]="mediaPath"
      />
  }

  @if (mediaPath && isVideoType) {
    <video
      style="max-width: 100%; width: 100%"
      controls
      #videoPlayer
      >
      <source [src]="mediaPath" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  }
  @if (mediaPath && showFullViewButton) {
    <button
      style="width: 100%"
      mat-raised-button
      color="primary"
      (click)="mediaClick()"
      type="button"
      >
      <mat-icon>zoom_out_map</mat-icon>
      Full View
    </button>
  }
</div>
